module.exports = "/_next/static/resources/water-db3b322ae3a1b72eeb24a51187689152.jpg";